import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface TenantNotice {
  message: string;
  type: string;
  active: boolean;
}

interface TenantNoticesState {
  notice: TenantNotice | null;
  dismissed: boolean;
  isLoading: boolean;
}

const initialState: TenantNoticesState = {
  notice: null,
  dismissed: false,
  isLoading: false,
};

export const tenantNoticesSlice = createSlice({
  name: "tenantNotices",
  initialState,
  reducers: {
    setTenantNotice: (state, action: PayloadAction<TenantNotice | null>) => {
      state.notice = action.payload;
      // Reset dismissed when a new notification is loaded
      state.dismissed = false;
      state.isLoading = false;
    },
    dismissNotice: (state) => {
      state.dismissed = true;
    },
    clearNotice: () => initialState,
    setLoading: (state, action: PayloadAction<boolean>) => {
        state.isLoading = action.payload;
      },
  },
});

export const { setTenantNotice, dismissNotice, clearNotice, setLoading } = tenantNoticesSlice.actions;
export default tenantNoticesSlice.reducer;

